import React from 'react';
import { whyChooseUs } from '../mock';
import { CheckCircle2 } from 'lucide-react';

export default function WhyGhana() {
  return (
    <section id="why-ghana" className="jh-section jh-dot-bg">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
        <div className="relative order-2 lg:order-1">
          <img
            src="https://customer-assets-jt897jd0.emergentagent.net/job_jh-intl-recruitment/artifacts/f30ovjfq_serve-file.png"
            alt="Ghanaian youth skilled trades training"
            className="rounded-2xl w-full h-[360px] sm:h-[440px] md:h-[560px] object-cover"
          />
          <div className="absolute -bottom-8 right-2 md:-right-8 bg-[#0e1421] text-white p-5 md:p-6 rounded-lg max-w-[240px] md:max-w-[280px] shadow-xl">
            <div className="text-[11px] md:text-[13px] uppercase tracking-widest text-white/70">
              Licence No.
            </div>
            <div className="font-display font-extrabold text-[28px] md:text-[34px] leading-none mt-1">
              PEA/819
            </div>
            <div className="text-[12px] md:text-[13px] text-white/70 mt-2">
              Government of Ghana — Ministry of Employment and Labour Relations
            </div>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <span className="jh-eyebrow">Why Ghana? Why John Herbert?</span>
          <h2 className="jh-h2 text-[#0e1421] mt-4 mb-6">
            A Trusted, Government-Licensed Recruitment Partner
          </h2>
          <p className="text-gray-600 leading-relaxed mb-8">
            At John Herbert Limited, ethical recruitment is central to
            everything we do. We work closely with the Government of Ghana and
            relevant regulatory institutions to ensure that all recruitment
            activities are lawful, transparent and conducted in accordance
            with national legislation and international best practices.
          </p>

          <div className="grid grid-cols-1 gap-3">
            {whyChooseUs.map((item) => (
              <div key={item} className="flex items-start gap-3">
                <CheckCircle2
                  size={20}
                  className="text-[#E11D2E] flex-shrink-0 mt-1"
                />
                <span className="text-[15px] text-[#0e1421]">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
